import { render, staticRenderFns } from "./CompletionProduct.vue?vue&type=template&id=56f953c3&scoped=true&"
import script from "./CompletionProduct.vue?vue&type=script&lang=ts&"
export * from "./CompletionProduct.vue?vue&type=script&lang=ts&"
import style0 from "./CompletionProduct.vue?vue&type=style&index=0&id=56f953c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f953c3",
  null
  
)

export default component.exports